<template>
    <part-replacement-detail name-table="part-replacement-history-equipment-detail-listing"></part-replacement-detail>
</template>
<script>
    const PartReplacementDetail = () => import("@/views/parts-replacement/detail.vue")

    export default {
        name: 'equipment-parts-replacement-detail',
        components: {
        	PartReplacementDetail
        },
    }
</script>
